import React, { FC } from 'react';
import styled from '@emotion/styled';

const Wrapper = styled.div`
  background-color: var(--colorBlueGray1300);
  width: 64px;
  overflow: hidden;
  display: flex;
  flex-flow: column nowrap;
  border-right: 1px solid var(--colorBlueGray1000);
  box-sizing: border-box;
`;

interface Props {
  children: JSX.Element;
}

const Sidebar = ({ children }: Props) => {
  return <Wrapper>{children}</Wrapper>;
};

export default Sidebar;
